import classname from 'classnames'
import { ReactComponent as SelectedDataElementIcon } from '@/assets/svgs/selected-radio-icon.svg'

const SelectorBox = ({ active, label, image, submit }) => {

	const selectorClass = classname({
		'selector-box-2': true,
		'selector-box-2--active': active
	})

	return (
		<div className={selectorClass} onClick={submit ? submit : null}>
			<div className="selector-box__left">
				{image && (<div className="selector-box__avatar" style={{ backgroundImage: `url(${image})` }}></div>)}
				<div className="selector-box__label">{label}</div>
			</div>
			<div className="selector-box__right">
				{!active && <div className="selector-box-2__circle"></div>}
				{active &&
				<div className='DS__icon--radio-icon'>
				<SelectedDataElementIcon />
				</div>}
			</div>
		</div>
	)
}

export default SelectorBox
